// src/components/MailMarketing.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SITE_CONFIG } from '../config';
import './MailMarketing.css';

const MailMarketing = () => {
  const navigate = useNavigate();
  const [contacts, setContacts] = useState([]);
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchContacts();
  }, []);

  const fetchContacts = async () => {
    try {
      const response = await fetch(`https://tophamtechbe.com/treas-postgrid/s3/get-address-list/${SITE_CONFIG.SITE_ID}`, {
        headers: {
          'X-API-Key': 'treas-api-key-2025'
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        setContacts(data.contacts || []);
      }
    } catch (error) {
      console.error('Error fetching contacts:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleContactSelect = (contact, index) => {
    const contactId = `${contact.Name}-${index}`;
    if (selectedContacts.includes(contactId)) {
      setSelectedContacts(selectedContacts.filter(id => id !== contactId));
    } else {
      setSelectedContacts([...selectedContacts, contactId]);
    }
  };

  const handleSelectAll = () => {
    if (selectedContacts.length === contacts.length) {
      setSelectedContacts([]);
    } else {
      setSelectedContacts(contacts.map((contact, index) => `${contact.Name}-${index}`));
    }
  };

  if (loading) {
    return <div className="mail-loading">Loading contacts...</div>;
  }

  return (
    <div className="mail-marketing">
      <div className="mail-header">
        <h1>Mail Marketing</h1>
        <button onClick={() => navigate('/admin')} className="back-admin-button">
          Back to Admin
        </button>
      </div>

      <div className="workflow-section">
        <div className="workflow-intro">
          <h2>Choose Your Target Audience</h2>
          <p>Select how you'd like to choose recipients for your mail campaign</p>
        </div>
        
        <div className="workflow-options">
          <div className="workflow-card" onClick={() => navigate('/admin/mail-marketing/contacts')}>
            <div className="workflow-icon">📋</div>
            <h3>Select from Contacts</h3>
            <p>Choose from your existing contact database</p>
            <div className="workflow-arrow">→</div>
          </div>
          
          <div className="workflow-card" onClick={() => navigate('/admin/mail-marketing/map')}>
            <div className="workflow-icon">🗺️</div>
            <h3>Select Address from Map</h3>
            <p>Target specific geographic areas and addresses</p>
            <div className="workflow-arrow">→</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MailMarketing;